import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { deleteTime, updateTimeItem } from "../../../../redux/slices/multiUrl";
import { handleLink } from "../../../../hooks/helpers";
import InputText from "../../../../components/input/inputText";
import { TrashIcon } from "../svg";
import { Button, Col, Form } from "react-bootstrap";
import InputSelect from "../../../../components/input/inputSelect";
import InputTime from "../../../../components/input/inputTime";
import PopoverBtn from "../../../../components/popoverBtn";
import { MAX_LINK_LENGTH } from "../../../../constants/inputValues";

export default function TimeItem({ time, timeIndex, error }) {
  const { times, lang, errorMsg } = useSelector((state) => ({
    times: state.multiUrl.times,
    lang: state.changeLang.language.stepTwo,
    errorMsg: state.changeLang.language.stepTwo.errors,
  }));

  const { id, timezoneId, startTime, endTime, link, linkValid } = time;

  const dispatch = useDispatch();
  const [allTimezones, setAllTimezones] = useState([]);

  useEffect(() => {
    axios("/api/locale/timezones").then(({ data }) => {
      setAllTimezones(
        data.map((item) => {
          return { id: item.id, timezone: `(GMT${item.GMT}) ${item.name}` };
        })
      );
    });
  }, []);

  const handleTimezoneSelect = (e) => {
    const selectId = e.target.value;
    dispatch(updateTimeItem({ id, timezoneId: selectId }));
  };

  return (
    <>
      <Col xs={12} md={11}>
        <div className="d-flex justify-content-between align-items-center fw-bold mb-1 mt-4">
          <small>
            {lang.multiUrl[14]} {timeIndex}
          </small>
          {times.length > 1 && (
            <Button
              variant="link"
              onClick={() => dispatch(deleteTime(id))}
              className="p-0 cursor-pointer"
            >
              <TrashIcon
                style={{
                  color: "#F44336",
                  cursor: "pointer",
                }}
              />
            </Button>
          )}
        </div>
      </Col>

      <InputSelect
        name="timezone"
        value={timezoneId}
        onChange={handleTimezoneSelect}
        defaultlabel={lang.multiUrl[15]}
        errorMessage={
          error &&
          !timezoneId && (
            <Form.Text className="text-danger">{lang.multiUrl[2]}</Form.Text>
          )
        }
        popoverText={lang.multiUrl[36]}
      >
        <option disabled={true} value={""}>
          {lang.multiUrl[15]}
        </option>
        {allTimezones.map((item) => (
          <option key={item.id} value={item.id}>
            {item.timezone}
          </option>
        ))}
      </InputSelect>

      <div className="position-relative">
        <Col xs={10} md={11}>
          <div className="d-flex gap-3">
            <InputTime
              value={startTime}
              name="startTime"
              onChange={(e) =>
                dispatch(updateTimeItem({ id, startTime: e.target.value }))
              }
              placeholder={lang.multiUrl[17]}
            >
              {error && !startTime && (
                <Form.Text className="text-danger">
                  {lang.multiUrl[2]}
                </Form.Text>
              )}
            </InputTime>

            <InputTime
              name="endTime"
              value={endTime}
              onChange={(e) =>
                dispatch(updateTimeItem({ id, endTime: e.target.value }))
              }
              placeholder={lang.multiUrl[18]}
            >
              {error && !endTime && (
                <Form.Text className="text-danger">
                  {lang.multiUrl[2]}
                </Form.Text>
              )}
            </InputTime>
          </div>
        </Col>
        <div className="position-absolute top-0 end-0 mt-3 w-auto me-3">
          <PopoverBtn text={lang.multiUrl[37]} />
        </div>
      </div>

      <InputText
        valid={linkValid && link.length > 3 && link.length <= MAX_LINK_LENGTH}
        error={
          (!linkValid && link.length > 3) ||
          (error && !link.length && !linkValid) ||
          link.length > MAX_LINK_LENGTH
        }
        type="link"
        name="timeLink"
        value={link}
        onChange={(e) =>
          handleLink(
            e.target.value,
            (linkValid) => dispatch(updateTimeItem({ id, linkValid })),
            (link) => dispatch(updateTimeItem({ id, link }))
          )
        }
        placeholder={lang.multiUrl[19]}
        popoverText={lang.multiUrl[38]}
      >
        {linkValid === false && link.length > 3 && (
          <Form.Text className="text-danger">
            {lang.link[2]}: https://me-qr.com/
          </Form.Text>
        )}
        {error && !link.length && !linkValid && (
          <Form.Text className="text-danger">{lang.linkEmpty}</Form.Text>
        )}
        {!linkValid && link.length > 0 && link.length < 4 && (
          <Form.Text className="text-danger">{lang.link[22]}</Form.Text>
        )}
        {link.length > MAX_LINK_LENGTH && (
          <Form.Text className="text-danger">{errorMsg[0]}</Form.Text>
        )}
      </InputText>
    </>
  );
}
